import { DashboardOutlined } from '@material-ui/icons';
import { formatMoney } from 'helpers/Currency';
import React, { useEffect, useState, useRef } from 'react';
import { Button, ButtonGroup, Card, Col, Container, Row, Spinner } from 'react-bootstrap';
import DashboardRequestService from 'services/dashboard-request';
import FilterIcon from "images/icons/filter.png";
import Axios from 'axios';
import Chart from "react-apexcharts";
import { useUser } from 'models';

export default function({
  onBack
}) {
  const { fiscal_year } = useUser()
  const [ technologies, setTechnologies ] = useState([]);
  const [ companies, setCompanies ] = useState([]);
  const [ groups, setGroups] = useState([]);
  const [ selected, setSelected ] = useState([]);
  const [ elite, setElite ] = useState([1,0,2,3]);
  const [ load, setLoad ] = useState(true);
  const [ pageSelected, setPageSelected ] = useState(1)
  const ref = useRef();
  
  const title = pageSelected===1?"Ranking":"Top 10 por segmento";

  useEffect(()=>{
    DashboardRequestService.getTechnologies().then(({data})=>{
      setSelected(data.map(d=>d.id));
      setTechnologies(data);
    })
  },[]);

  useEffect(()=>{
    if(selected.length > 0){
      setLoad(true)
      let aux_token_cancel_request = Axios.CancelToken.source();
      DashboardRequestService.getRankingByTechnologies(fiscal_year.id,{technologies:selected, elite},aux_token_cancel_request.token).then(({data})=>{
        setCompanies(data);
        setLoad(false)
      })
      return ()=>{
        aux_token_cancel_request.cancel('');
      }
    }
  },[selected, elite]);

  useEffect(()=>{
    if(selected.length > 0){
      setLoad(true)
      let aux_token_cancel_request = Axios.CancelToken.source();
      DashboardRequestService.getRankingTechnologiesByPos(fiscal_year.id,[1,2,3,4,5,6,7,8,9,10],aux_token_cancel_request.token).then(({data})=>{
        let groups = [];
        data.forEach((item)=>{
          let aux = groups.filter((g)=>g.id === item.technology_id);
          if(aux.length > 0){
            aux[0].companies.push(item);
          } else {
            groups.push({
              id:item.technology_id,
              name:item.technology_name,
              companies:[item]
            });
          }
        })
        setGroups(groups);
      })
      return ()=>{
        aux_token_cancel_request.cancel('');
      }
    }
  },[selected, elite]);


  return (
    <Container fluid className="mb-5 add-dashboard" ref={ref}>
      <Row className="mt-2">
        <Col xs="auto">
          <Button size="sm" onClick={()=>{
            if(ref && ref.current){
              let element = ref.current;
              element.classList.remove("add-dashboard")
              element.classList.add("remove-dashboard")
              if(onBack){
                setTimeout(()=>{
                  onBack();
                },1000);
              }
            }
          }}>Voltar</Button>
        </Col>
        <Col md="auto" className="d-flex p-0">
          <DashboardOutlined className="icon-title" />
          <h5 className="title-dashboard">Dashboard Ranking</h5>
        </Col>
      </Row>
      <Row>
        {pageSelected===1?(
          <Col xs={3}>
            <Row>
              <Col xs="12" className="mb-2">
                <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100 p-2">
                  <div className="area-filters-raking">
                    <Row>
                      <Col>
                        <h5>Elite</h5>
                      </Col>
                      <Col xs="auto">
                        <div className={"btn-filter "+(elite.length === 4?"disabled-li":"")} onClick={()=>{
                          if(elite.length === 2){
                            return;
                          }
                          setElite([1,0,2,3]);
                        }}>
                          <img src={FilterIcon} alt="filter-icon"/>
                        </div>
                      </Col>
                    </Row>
                    <ul>
                      {[
                        {name:"Sim",id:1},
                        {name:"Não",id:0},
                      ].map((eli,key)=>{
                        return (
                          <li id={`elite-f-${eli.id}`} className={elite.indexOf(eli.id) !== -1?"":"disabled-li"} key={key} onClick={()=>{
                            [
                              {name:"Sim",id:1},
                              {name:"Não",id:0},
                            ].forEach((item)=>{
                              const element = document.getElementById(`elite-f-${item.id}`);
                              element.classList.add("disabled-li");
                            })
                            const element = document.getElementById(`elite-f-${eli.id}`);
                            element.classList.remove("disabled-li");
                            setTimeout(()=>{
                              if(eli.id === 1){
                                setElite([eli.id,2,3  ])
                              } else {
                                setElite([eli.id])
                              }
                            },10);
                          }}>{eli.name}</li>
                        );
                      })}
                    </ul>
                  </div>
                </Card.Body>
              </Col>
              <Col xs="12">
                <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100 p-2">
                  <div className="area-filters-raking">
                    <Row>
                      <Col>
                        <h5>Tecnologias</h5>
                      </Col>
                      <Col xs="auto">
                        <div className={"btn-filter "+(technologies.length === 0 || selected.length > 1?"disabled-li":"")} onClick={()=>{
                          if(technologies.length === 0 || selected.length > 1){
                            return;
                          }
                          setSelected(technologies.map(d=>d.id));
                        }}>
                          <img src={FilterIcon} alt="filter-icon"/>
                        </div>
                      </Col>
                    </Row>
                    <ul>
                      {technologies.map((tec,key)=>{
                        return (
                          <li id={`tec-${tec.id}`} className={selected.indexOf(tec.id) !== -1?"":"disabled-li"} key={key} onClick={()=>{
                            technologies.forEach((item)=>{
                              const element = document.getElementById(`tec-${item.id}`);
                              element.classList.add("disabled-li");
                            })
                            const element = document.getElementById(`tec-${tec.id}`);
                            element.classList.remove("disabled-li");
                            setTimeout(()=>{
                              setSelected([tec.id])
                            },10);
                          }}>{tec.name}</li>
                        );
                      })}
                    </ul>
                  </div>
                </Card.Body>
              </Col>
            </Row>
          </Col>
        ):<></>}
        <Col>
          <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100 card-table-ranking">
            <Row>
              <Col>
                {title}
              </Col>
              <Col xs="auto">
                <ButtonGroup aria-label="Basic example">
                  <Button size="sm" disabled={pageSelected===1} onClick={()=>{setPageSelected(1)}}>Ranking</Button>
                  <Button size="sm" disabled={pageSelected===2} onClick={()=>{setPageSelected(2)}}>Top 10 por segmento</Button>
                </ButtonGroup>
              </Col>
            </Row>
            {pageSelected===1?(
              <div className="area-table-ranking">
                <table className="table-ranking">
                  <thead>
                    <tr>
                      <th className="col-min"></th>
                      <th>Rótulos de Linha</th>
                      <th className="col-min">Soma de GROSS SALES</th>
                    </tr>
                  </thead>
                  <tbody>
                    {load?(
                      <tr>
                        <td colSpan={3} className="text-center">
                          <Spinner animation="border" />
                        </td>
                      </tr>
                    ):companies.map((company,key)=>{
                      return (
                        <tr key={key}>
                          <td className="col-min">{key+1}°</td>
                          <td>{company.company_name}</td>
                          <td className="col-min text-right">{formatMoney(company.value)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ):(
              <Row>
                {groups.map((group,key)=>{
                  return (
                    <Col md="6" key={key}>
                      <div className="card-top-10-raking">
                        <h6 className="w-100">{group.name}</h6>
                        <Chart
                          options={
                            {
                              chart: {
                                id: "basic-bar"
                              },
                              xaxis: {
                                categories: group.companies.map((item)=>item.company_name)
                              },
                              yaxis: {
                                labels: {
                                  formatter: (value) => { return formatMoney(value) },
                                }
                              },
                              dataLabels:{
                                enabled: false,
                              }
                            }
                          }
                          series={[
                            {
                              name: "Valor",
                              data: group.companies.map((item)=>item.value)
                            }
                          ]}
                          type="bar"
                          width="100%"
                        />
                      </div>
                    </Col>
                  );
                })}
              </Row>
            )}
          </Card.Body>
        </Col>
      </Row>

    </Container>
  )
}